module.exports = __webpack_public_path__ + "static/img/system_4.ab814edb.svg";